// extracted by mini-css-extract-plugin
module.exports = {"editedEssay":"style-module__editedEssay___cgEV7","popover":"style-module__popover___15gSN"};